module.exports = __webpack_public_path__ + "static/media/ico-filter.5fc9aa49.svg";